/* unplugin-vue-components disabled */import script from "./NoticeWrapper.vue?vue&type=script&setup=true&lang=tsx"
export * from "./NoticeWrapper.vue?vue&type=script&setup=true&lang=tsx"

const cssModules = {}
import style0 from "./NoticeWrapper.vue?vue&type=style&index=0&id=68d82c89&lang=postcss&module=css"
cssModules["css"] = style0

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.2.2_vue@3.3.4+webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__